import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { isCarrierPackageId } from '@shipstation/client-common/utils/package-utils';
import { hasAnyDimensionValues } from '@shipstation/client-common/utils/dimensions';
import { useEnableCarrierPackageDimensionLock } from '../../../feature-flags/hooks/use-enable-carrier-package-dimension-lock';

export const useIsCarrierPackageWithDimensions = (packageId: string) => {
  const isCarrierPackageDimensionLockEnabled = useEnableCarrierPackageDimensionLock();
  const sellerPackage = useSelector((state) => {
    const sellerPackages = Global.selectSellerPackages(state);
    return sellerPackages.find((p) => p.packageId === packageId);
  });

  return isCarrierPackageDimensionLockEnabled && isCarrierPackageId(packageId) && hasAnyDimensionValues(sellerPackage?.dimensions);
};
